export function buildMentorshipShareUrl(programId: number): string {
  const envBase = (process.env.NEXT_PUBLIC_APP_SITE_URL || '').replace(
    /\/$/,
    ''
  );
  if (typeof window !== 'undefined') {
    const origin = envBase || window.location.origin;
    return `${origin.replace(/\/$/, '')}/mentorship/${programId}`;
  }
  return envBase ? `${envBase}/mentorship/${programId}` : '';
}
